// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QHf3","name":"styles_name__3OUAV","phone":"styles_phone__3UO-m"};